import type { RouteRecord } from 'vite-react-ssg'
import Layout from './components/Layout'
import { team } from './data/team'

// Each page is a lazy chunk, so a visitor downloads only the code for the page
// they land on (plus the shared Layout + vendor), not the whole site. vite-react-ssg
// prerenders every route at build and preloads the matched route's chunk (it detects
// the literal import() in each lazy function), so there is no load waterfall. Pages
// default-export their component; `.then` adapts that to the { Component } the router wants.
const pages = (): RouteRecord[] => [
  { index: true, lazy: () => import('./pages/Home').then((m) => ({ Component: m.default })) },
  { path: 'about', lazy: () => import('./pages/About').then((m) => ({ Component: m.default })) },
  { path: 'who-we-serve', lazy: () => import('./pages/Serve').then((m) => ({ Component: m.default })) },
  { path: 'programs', lazy: () => import('./pages/Programs').then((m) => ({ Component: m.default })) },
  { path: 'programs/young-adults', lazy: () => import('./pages/YoungAdults').then((m) => ({ Component: m.default })) },
  { path: 'programs/adults', lazy: () => import('./pages/Adults').then((m) => ({ Component: m.default })) },
  { path: 'programs/keys', lazy: () => import('./pages/Keys').then((m) => ({ Component: m.default })) },
  { path: 'housing-model', lazy: () => import('./pages/Model').then((m) => ({ Component: m.default })) },
  { path: 'refer', lazy: () => import('./pages/Refer').then((m) => ({ Component: m.default })) },
  { path: 'outcomes', lazy: () => import('./pages/Outcomes').then((m) => ({ Component: m.default })) },
  { path: 'get-involved', lazy: () => import('./pages/Involved').then((m) => ({ Component: m.default })) },
  { path: 'partner', lazy: () => import('./pages/Partner').then((m) => ({ Component: m.default })) },
  { path: 'give', lazy: () => import('./pages/Give').then((m) => ({ Component: m.default })) },
  { path: 'contact', lazy: () => import('./pages/Contact').then((m) => ({ Component: m.default })) },
  { path: 'privacy', lazy: () => import('./pages/Privacy').then((m) => ({ Component: m.default })) },
  { path: 'terms', lazy: () => import('./pages/Terms').then((m) => ({ Component: m.default })) },
  { path: 'director', lazy: () => import('./pages/Director').then((m) => ({ Component: m.default })) },
  { path: 'team', lazy: () => import('./pages/Team').then((m) => ({ Component: m.default })) },
  { path: 'resources', lazy: () => import('./pages/Resources').then((m) => ({ Component: m.default })) },
  // One prerendered profile page per team member. All share the Member chunk;
  // Member reads which member from the URL (no dynamic params, SSG-friendly).
  ...team.map((m) => ({ path: `team/${m.key}`, lazy: () => import('./pages/Member').then((mod) => ({ Component: mod.default })) })),
]

export const routes: RouteRecord[] = [
  { path: '/', element: <Layout />, entry: 'src/components/Layout.tsx', children: pages() },
  { path: '/es', element: <Layout />, entry: 'src/components/Layout.tsx', children: pages() },
]
